export default __webpack_public_path__ + "static/media/327.dc8e0a7c.gif";